<template>
  <div class="ios-barcode">
    <p class="text-center text-secondary">如果手機連接條碼掃描器後無法開啟輸入法，請使用條碼掃描器掃描下面的條碼。</p>
    <div class="text-center">
      <img class="img-fluid" :src="require('@/assets/imgs/barcode.png')" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'IOSBarcode',
}
</script>

<style scoped>
  .ios-barcode {
    
  }
</style>
